import React from 'react'
import { View } from 'react-native'
import { Icon, Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'

export interface EmptyEventsPlaceholderProps {
  footer?: React.ReactNode
}

export const EmptyEventsPlaceholder = React.memo(({ footer }: EmptyEventsPlaceholderProps) => {
  const styles = useStyleSheet(themedStyle)

  return (
    <View style={styles.container}>
      <Icon name="hand-waving" style={styles.iconStyle} />
      <View style={styles.textContainer}>
        <Text type="title-3" style={styles.title}>
          Hey, looks empty here!
        </Text>
        <Text type="regular" style={styles.subtitle}>
          Tap the + button to add an event or view all past events.
        </Text>
      </View>
      {footer}
    </View>
  )
})

const themedStyle = StyleService.create({
  container: {
    alignItems: 'center',
    marginTop: 16,
    flexDirection: 'column',
    paddingHorizontal: 40,
  },
  textContainer: {
    marginTop: 8,
  },
  title: {
    textAlign: 'center',
    marginTop: 8,
    marginBottom: 10,
    color: 'theme.text.secondary',
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: 8,
    color: 'theme.text.tertiary',
  },
  iconStyle: {
    color: 'theme.primary.base',
    width: 32,
    height: 32,
  },
})
